export function isUserAgentAllowedForRecording(userAgent) {

  // Android Messenger https://gist.github.com/etienne-martin/bea6b38c6999c720d91bd77010fae4f4
  // Android Instagram https://whatmyuseragent.com/apps/instagram-app, https://mpulp.mobi/2016/07/12/instagram-user-agent/
  return !/(android.*fb_iab.*)|(android.*fbav.*)|(instagram.*android.*)/.test(userAgent.toLowerCase())
}
